"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommonRect = void 0;
const minBy_1 = __importDefault(require("lodash/minBy"));
const maxBy_1 = __importDefault(require("lodash/maxBy"));
const getCommonRect = rects => {
  const {
    left
  } = (0, minBy_1.default)(rects, 'left');
  const {
    right
  } = (0, maxBy_1.default)(rects, 'right');
  const {
    top
  } = (0, minBy_1.default)(rects, 'top');
  const {
    bottom
  } = (0, maxBy_1.default)(rects, 'bottom');
  const width = right - left;
  const height = bottom - top;
  return {
    left,
    right,
    top,
    bottom,
    width,
    height
  };
};
exports.getCommonRect = getCommonRect;